import React, { useEffect, useState } from 'react';

import { useToolbarBoundary } from './../../toolbar-boundary';

export const MaxWidthCalculationWrapper = ({
  setMaxWidth,
  children,
  otherWrapper,
  ...divProps
}: {
  setMaxWidth: (width: number) => void;
  children: React.ReactNode;
  otherWrapper?: HTMLElement | null;
} & React.HTMLAttributes<HTMLDivElement>) => {
  const containerElement = useToolbarBoundary();

  const [wrapper, setWrapper] = useState<null | HTMLDivElement>(null);

  useEffect(() => {
    const observableWrapper = otherWrapper !== undefined ? otherWrapper : wrapper;

    if (!observableWrapper || !containerElement) {
      return;
    }

    setMaxWidth(containerElement.clientWidth);

    const resizeObserver =
      window?.ResizeObserver &&
      new ResizeObserver(() => {
        setMaxWidth(containerElement.clientWidth);
      });

    resizeObserver?.observe(observableWrapper);

    return () => resizeObserver?.disconnect();
  }, [wrapper, otherWrapper, containerElement?.clientWidth]);

  if (otherWrapper === null) {
    return <>{children}</>;
  }

  if (otherWrapper) {
    return <div {...divProps}>{children}</div>;
  }

  return (
    <div {...divProps} ref={setWrapper}>
      {children}
    </div>
  );
};
